import { GlassContainer } from "src/components/MitGlassComponents"


type JobServiceRejseplanLeg = {
   properties: {
      name: string
      type: string
      duration: number
      startTime: string
      dist: number
      origin: string
      originTime: string
      destination: string
      destinationTime: string
   } | {
      Navn: string
      Type: string
      "Rejse tid": number
      Længde: number
      Start: string
      "Start tid": string
      Slut: string
      "Slut tid": string
   }
}

export function RejseplanRoute(props: { spatial: string }) {
   const spatial = JSON.parse(props.spatial || "{}") as { Rejseplanen: { features: JobServiceRejseplanLeg[] } }
   if (!spatial.Rejseplanen) return null
   const length = spatial.Rejseplanen.features.length

   return (
      <GlassContainer title="Rejseplanen">
         <div className="Rejseplanen">
            {spatial.Rejseplanen.features.map((leg, i) => {
               let prop = leg.properties
               if ("Navn" in prop) {
                  return (
                     <div key={i} className="leg">
                        <div className="name">{prop.Navn}</div>
                        <div className="time"><div>{prop["Start tid"]}</div><div>{durationHR(prop["Rejse tid"])}</div><div>{prop["Slut tid"]}</div></div>
                        <div className="places"><div>{nameFormat(prop.Start, i == 0)}</div><div>{distanceHR(prop.Længde)}</div><div>{nameFormat(prop.Slut, i == length - 1)}</div></div>
                     </div>
                  )
               }
               return (
                  <div key={i} className="leg">
                     <div className="name">{prop.name}</div>
                     <div className="time"><div>{prop.startTime}</div><div>{durationHR(prop.duration)}</div><div>{prop.destinationTime}</div></div>
                     <div className="places"><div>{nameFormat(prop.origin, i == 0)}</div><div>{distanceHR(prop.dist)}</div><div>{nameFormat(prop.destination, i == length - 1)}</div></div>
                  </div>
               )
            })}
         </div>
      </GlassContainer>
   )
}

function nameFormat(name, firstLast?: boolean) {
   if (name == "HL" && !firstLast)
      return "Vinkestrækning"
   return name
}

function durationHR(duration: number) {
   const hours = Math.floor(duration / 3600)
   const minutes = Math.floor((duration % 3600) / 60)
   const seconds = duration % 60
   return `${hours ? hours + "h " : ""}${minutes ? minutes + "m " : ""} ${(seconds || 0) + "s"}`
}

function distanceHR(dist: any) {
   if (typeof dist === "number")
      return `${dist.toLocaleString()}m`
   return dist
}